<template>
    <div class="toggle">

        <div class="btn cursor-pointer" :class="{select:checkSelected(1)}" @click="selectBtn()">
            {{text1}}
        </div>
        |
        <div class="btn cursor-pointer" :class="{select:checkSelected(2)}" @click="selectBtn()">
            {{text2}}
        </div>

    </div>
</template>

<script>
export default {
  name: "time-toggle",
  props: {
    text1: {
      type: String,
      default: "ไตรมาส"
    },
    text2: {
      type: String,
      default: "ปี"
    },
    select: {
      type: Number,
      default: 2
    },
    selectFunction: {
      type: Function,
      default: () => { }
    }
  },
  methods: {
    selectBtn() {
      if (this.select === 1) {
        this.selectFunction(2)
      } else {
        this.selectFunction(1)
      }
    },
    checkSelected(index) {
      return this.select === index;
    }
  }
};
</script>

<style lang='scss' scoped>
.toggle {
  display: inline;
  padding: 0px 4px;
  color: $grey;

  .btn {
    display: inline-block;
    font-size: 12px;
    padding: 0px 7px;
    min-width: 44px;
    text-align: right;

    &.select {
      font-weight: bold;
      color: $black;
    }

    &:nth-child(2) {
      text-align: left;
      margin-left: -2px;
    }
  }
}

@media screen and (max-width: 420px) {
  .toggle {
    .btn {
      margin-top: 12px !important;
      min-width: 0px !important;
    }
  }
}
</style>
